import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';
class StopTrigger extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({ hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false, });
    };
    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchStopTriggerDataApi()
        this.dialogClose();
      }
    }];
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchStopTriggerDataApi()
        this.dialogClose();
        this.setState({
          disabled: false
        })
      }
    }];
    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': props => {
        this.deleteStopTriggerApi(this.state.propsId)
        this.setState({ disabled: false })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];

    //for delete success
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': props => {
        this.dialogInstance.hide();
        this.fetchStopTriggerDataApi()
        this.setState({ disabled: false })
      }
    }];

    this.state = {
      language: null,
      data: [{ id: '', text: '', autoTranslate: '' }],
      intentId: '',
      domainId: '',
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,

    }
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }

  notifyFailToCreate() {
    toast(<b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>, {
      position: "top-center",
      color: "red"
    });
  }
  addRow = (data) => {
    var stopTriggerController = this;
    if (stopTriggerController.state.pageNum != 0) {
      stopTriggerController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      id: '',
      text: '',
      autoTranslate: '',
    });

    this.setState({
      data: this.state.data,
      disabled: true,

    })
  }
  saveStopTriggerApi = (props, e) => {
    props.original.text = document.getElementById('text' + props.index).innerText.trim();
    props.original.autoTranslate = document.getElementById('autoTranslate' + props.index).checked;
    this.state.editedId = "-1";
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.text);

    if (validateResult == true) {
      var addedData = {
        intentId: this.props.location.state.intentId,
        text: props.original.text,
        language: document.getElementById('language').value,
        projectId: localStorage.getItem("currentProjectId"),
        domainId: this.props.location.state.domainId,
        autoTranslate: props.original.autoTranslate,

      };

      var addStopTriggerController = this
      $.ajax({
        url: "/api/stoptriggers",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(addedData),
        success: function (res) {
          if (res.success === true) {
            addStopTriggerController.notifyAdded();
            addStopTriggerController.fetchStopTriggerDataApi();
            addStopTriggerController.setState({ disabled: false });
          } else {
            addStopTriggerController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) { window.location.href = "/platform/"; }
        }
      })
    }
  }

  makeCelleditable(props, e) {
    this.markAsBeingEdited(props.original.id);
  }
  markAsBeingEdited(id) {

    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  updateStopTriggerApi(props, e) {
    props.original.text = document.getElementById('text' + props.index).innerText.trim();
    props.original.autoTranslate = document.getElementById('autoTranslate' + props.index).checked;
    var validateResult = this.validateCells(props.original.text);
    if (validateResult == true) {
      var updatedData = {
        id: props.original.id,
        intentId: this.props.location.state.intentId,
        text: props.original.text,
        language: document.getElementById('language').value,
        projectId: localStorage.getItem("currentProjectId"),
        domainId: this.props.location.state.domainId,
        autoTranslate: props.original.autoTranslate,
      };

      var updatedStopSluTriggerController = this
      $.ajax({
        url: "/api/stoptriggers",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(updatedData),
        success: function (res) {
          if (res.success === true) {
            updatedStopSluTriggerController.state.editedId = "-1";
            updatedStopSluTriggerController.notifyUpdate();
            updatedStopSluTriggerController.fetchStopTriggerDataApi();
          } else {
            updatedStopSluTriggerController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
  }

  validateCells(text) {
    if ((text == "")) {
      this.notifyEmptyFields();
      return false;
    } else {
      return true;
    }
  }
  deleteStopTriggerApi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
    } else {
      $.ajax({
        url: "/api/stoptriggers/" + id,
        async: false,
        method: 'DELETE',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
          } else {
            deleteRowViewController.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) { window.location.href = "/"; }
        }

      });
    }
    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchStopTriggerDataApi();
  }

  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.fetchStopTriggerDataApi()
    this.setState({ disabled: false })
  }
  handleChange = (event) => {
    this.setState({
      value: event.target.value,
      language: document.getElementById('language').value
    });
    this.fetchStopTriggerDataApi();
  }
  fetchLanguagesApi() {
    var languageController = this;
    $.ajax(
      {
        url: "/api/project-languages",
        async: false,
        method: 'GET',
        data: { projectId: localStorage.getItem("currentProjectId"), },
        headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token"), 'Content-Type': 'application/json' },
        success: function (res) {
          if (res.success === true) {
            var language = res.result.languages;
            languageController.setState({ language: language });
            var numberOfLanguages = language.length;
            var ele3 = document.getElementById("language");
            if (ele3 != null) {
              ele3.innerHTML = null;
              for (var i = 0; i < numberOfLanguages; i++) {
                ele3.innerHTML = ele3.innerHTML + '<option value="' + language[i]['language'] + '">' + language[i]['language'] + '</option>';
              }
            }
            successResp: true
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) { window.location.href = "/platform/"; }
        }
      }
    )

  }
  fetchStopTriggerDataApi = () => {
    var otherFormController = this;
    $.ajax({
      url: "/api/stoptriggers",
      async: false,
      method: 'GET',
      data: {
        "intentId": this.props.location.state.intentId,
        language: document.getElementById('language').value
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token"), },
      success: function (res) {
        if (res.success === true) {
          var messages = res.result;
          otherFormController.setState({
            data: messages,
            successResp: true
          })
        } else { otherFormController.notifyError(); }
      },
      error: function (xhr) {
        if (xhr.status == 401) { window.location.href = "/platform/"; }
      }
    });
  }
  componentDidMount() {

    var intentId = this.props.location.state.intentId
    var domainId = this.props.location.state.domainId
    this.state = { intentId: intentId, domainId: domainId }
    setTimeout(() => {
      this.fetchLanguagesApi();
      this.fetchStopTriggerDataApi();
    }, 300);

    var thisCOntroller = this;
    document.addEventListener("projectChanged", function (event) {
      thisCOntroller.props.history.push("/projectmgmt/nlutab");
    });

  }
  handleLangChange = (e) => {
    this.state.disabled = false
    this.fetchStopTriggerDataApi();
  }
  goBack = () => {
    this.props.history.push({
      pathname: "/projectmgmt/nlutab",
      state: { goBackToSlu: true }
    });
  }
  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"
    });
  }

  notifyAdded() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Added Successfully</b>, {
      position: "top-center",
    });
  }

  notifyError() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }

  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Updated Successfully</b>, {
      position: "top-center",
    });
  }

  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Deleted Successfully</b>, {
      position: "top-center",
    });
  }
  notifyEmptyFields() {
    toast(<b>Please fill all fields</b>, {
      position: "bottom-center",
      color: "#007aff"
    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }


  render() {
    const { data } = this.state
    const columns = [
      {
        Header: 'ID',
        accessor: 'id',
        show: false,
        Cell: props => (
          <div name="id" id={"id" + props.index}>{props.original.id}</div>)
      },

      {
        Header: <b>Text</b>,
        accessor: 'text',
        Cell: props => {
          return (

            <div className="input" type="text" defaultValue={props.original.text}
              style={{ width: '97%', height: "90%", paddingTop: '6px', paddingLeft: '2px', borderBottom: 'none', border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none' }}
              id={"text" + props.index}
              disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId}
              contentEditable={!((props.original.id == '') ? false :
                props.original.id != this.state.editedId) ? "plaintext-only" : false}
              >{props.original.text}
            </div>
          )
        }
      },

      {
        Header: <b>AutoTranslate</b>,
        accessor: 'autoTranslate',
        sortable: false,
        width: 100,
        Cell: props => {
          return (
            <div style={{ textAlign: 'center' }}>
              <label class="switch" style={{ marginTop: '5px' }}>
                <input type="checkbox" id={"autoTranslate" + props.index}
                  defaultChecked={props.original.autoTranslate}
                  disabled={(props.original.id == "") ? false : props.original.id != this.state.editedId} />
                <span class="slider round"></span>
              </label>
            </div>
          )
        }
      },
      {
        Header: <b>Action</b>,
        accessor: 'action',
        width: 100,

        sortable: false,
        Cell: props => (
          <div id="action">
            <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-3px', marginLeft: '-6px' }} >
              <img className="img-responsive"
                title={(props.original.id == "") ||
                  (props.original.id == this.state.editedId) ? 'Save' : 'Edit'}
                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                src={(props.original.id == "") ? this.saveImageSrc : ((props.original.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                onClick={(e) => {
                  (props.original.id == "") ? this.saveStopTriggerApi(props, e) : (props.original.id == this.state.editedId) ?
                    this.updateStopTriggerApi(props, e) : this.makeCelleditable(props, e);
                }} />
            </button>


            <button style={{
              backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
            }} title="Delete">
              <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                }}
                onClick={() => (props.original.id) === '' ?
                  this.fetchStopTriggerDataApi() :
                  this.setState({
                    hideDeletePopup: true, deletePropIndex: props.index,
                    propsId: props.original.id
                  })}
              /></button>
          </div>
        ),

      },

    ]

    return (
      <div style={{ marginRight: '1%' }}>
        <Loader type="TailSpin" color="#282a65" visible={(this.state.successResp) ? false : true}
          height={300} width={50} timeout={2000} style={{ textAlign: 'center' }} />
        <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }}>
          {/* StyleSheet for Toaster ,ReactTable,Dialog Component, Font Awesome Icons,Theme Style,for Select  */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="./assets/css/react-table-height.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />

          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-3" style={{ marginTop: "16px" }}>
                <img src="assets/images/arrow.svg" onClick={this.props.history.goBack}
                  style={{ width: '24px', cursor: 'pointer' }} />
              </div>

              <div className="col-sm-4" Align='right'>
                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '18px' }}>
                  Cancellation Triggers for {this.props.location.state.intentName}</h6>
              </div>

              <div className="col-sm-5" Align='right'>
                <select className="input-group mb-3 form-control select2 "
                  id="language" value={this.state.value} style={{ display: 'inline-block', width: '40%', marginRight: '3%' }}
                  onChange={this.handleChange} tabIndex={-1} aria-hidden="true" >
                </select>
                <button className="btn action-button" id="addMsg" title=" Add "
                  onClick={this.state.disabled ? this.notifyEmptyFields : this.addRow}>
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button title="Refresh" onClick={this.refreshData} className="btn action-button">
                  <img src="./assets/images/refresh_white_24dp.png"></img>
                </button>
              </div>
            </div>
          </div>

          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 ">
                  <div className="card">
                    <ReactTable
                      data={data}
                      columns={columns}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}
                      onPageChange={this.onPageChange}
                      page={this.state.pageNum}
                    />
                  </div>
                  <ToastContainer className="Toast-at-center" />

                  {/*Dialog Component For Deletion Confirmation*/}
                  <DialogComponent width='400px' animationSettings={this.settings}
                    header='Stop Trigger' showCloseIcon={true} buttons={this.buttons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideDeletePopup} close={this.dialogClose}>
                    <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                      content="" />&nbsp;Do you want to delete Cancellation Triggers?<br />Note: Press 'Yes' to delete or press 'No' to decline.
                  </DialogComponent>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default StopTrigger;


// WEBPACK FOOTER //
// ./src/projectmgmt/nlu/intent/StopTrigger.js